<template>
  <div class="contrato-dashboard">

    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-start">
              <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                <lg-status-card :value="dashboardData.quantidadeContratosVigentes || 0" label="Contratos vigentes" sublabel="Ativos" variant="success" icon="file-earmark-check" />
              </div>
              <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                <lg-status-card :value="dashboardData.quantidadeTotalItens || 0" label="Itens em contratos" sublabel="Vigentes" variant="warning" icon="collection" />
              </div>
              <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                <lg-status-card :value="formatCurrency(dashboardData.valorTotalRegistrado)" label="Valor total" sublabel="Registrado" variant="primary" icon="currency-dollar" />
              </div>
              <div class="col-lg-3 col-md-6 mt-md-0 mt-4 d-flex align-items-start justify-content-end">
                <div class="btn-group">
                  <b-button size="sm" variant="outline-primary" @click="exportToPDF" title="Exportar PDF">
                    <b-icon icon="file-earmark-pdf" />
                  </b-button>
                  <b-button size="sm" variant="outline-success" @click="exportToExcel" title="Exportar Excel">
                    <b-icon icon="file-earmark-excel" />
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-0">Quantidade de Contratos por Mês</h4>
            <div class="d-flex flex-column flex-lg-row">
              <p>Visualize a quantidade de Contratos registradas por mês</p>
              <div class="filter-wrapper ml-lg-auto d-flex">
                <div class="status-filter mr-2">
                  <b-dropdown text="Status" variant="secondary" size="sm">
                    <b-dropdown-form>
                      <b-form-checkbox v-model="selectedStatusesChart.all" @change="onAllStatusChangeChart">
                        Todos os Status
                      </b-form-checkbox>
                      <b-form-checkbox v-model="selectedStatusesChart.vigente" @change="onStatusChangeChart">
                        Vigentes
                      </b-form-checkbox>
                      <b-form-checkbox v-model="selectedStatusesChart.expirado" @change="onStatusChangeChart">
                        Expiradas
                      </b-form-checkbox>
                      <b-form-checkbox v-model="selectedStatusesChart.naoIniciado" @change="onStatusChangeChart">
                        Não Iniciadas
                      </b-form-checkbox>
                    </b-dropdown-form>
                  </b-dropdown>
                </div>
                <select class="form-control form-control-local form-control-sm" v-model="selectedYear" @change="filterByYear">
                  <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
            </div>
            <div class="chart-container mt-4" style="height: 300px;">
              <canvas id="itensChartContratos"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body d-flex flex-column">
            <div class="wrapper">
              <h4 class="card-title mb-0">Status dos Contratos</h4>
              <p>Distribuição por status</p>
              <div class="mb-4" id="status-legend-contratos">
                <div class="chartjs-legend">
                  <ul>
                    <li><span style="background-color:rgba(75, 192, 192, 0.6)"></span>Vigentes</li>
                    <li><span style="background-color:rgba(255, 99, 132, 0.6)"></span>Expiradas</li>
                    <li><span style="background-color:rgba(255, 206, 86, 0.6)"></span>Não Iniciadas</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="chart-container my-auto mx-auto" style="height: 280px; width: 100%;">
              <canvas id="statusChartContratos"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Chart from 'chart.js';
import ResourceService from "@/core/api/ResourceService";
import LgStatusCard from "@/core/components/Cards/LgStatusCard.vue";

export default {
  components: { LgStatusCard },
  data() {
    return {
      dashboardData: {
        quantidadeContratosVigentes: 0,
        quantidadeTotalItens: 0,
        valorTotalRegistrado: 0,
        quantidadeAdesoes: 0,
        contratosVigentes: [],
        distribuicaoItens: [],
        contratosPorMes: [],
        statusContratos: {
          vigentes: 0,
          expiradas: 0,
          naoIniciadas: 0
        }
      },
      selectedAtaId: '',
      currentPeriod: 'all',
      chartView: 'items',
      itensChartContratos: null,
      statusChartContratos: null,
      contratosVigentesLineChart: null,
      itensLineChartContratos: null,
      valorLineChart: null,
      adesoesLineChart: null,
      selectedYear: new Date().getFullYear(),
      availableYears: [],
      selectedStatusesChart: {
        all: true,
        vigente: false,
        expirado: false,
        naoIniciado: false
      }
    };
  },
  computed: {
    upcomingExpirations() {
      if (!this.dashboardData.contratosVigentes || this.dashboardData.contratosVigentes.length === 0) {
        return [];
      }

      const today = new Date();
      const thirtyDaysFromNow = new Date();
      thirtyDaysFromNow.setDate(today.getDate() + 30);

      return this.dashboardData.contratosVigentes
        .filter(ata => {
          const expirationDate = new Date(ata.dataFinal);
          return expirationDate > today && expirationDate <= thirtyDaysFromNow;
        })
        .sort((a, b) => new Date(a.dataFinal) - new Date(b.dataFinal))
        .slice(0, 5);
    }
  },
  beforeMount() {
    this.$service = new ResourceService("/api/contratos");

    for (let year = 2000; year <= 2099; year++) {
      this.availableYears.push(year);
    }

    this.loadDashboard();
  },
  methods: {
async loadDashboard() {
  try {
    let url = `dashboard?year=${this.selectedYear}`;

    if (!this.selectedStatusesChart.all) {
      const statusIds = this.getSelectedStatusIdsChart();
      if (statusIds.length > 0) {
        url += `&statusIds=${statusIds.join(',')}`;
      }
    }

    const response = await this.$service.get(url);
    this.dashboardData = response.data;

    this.$nextTick(() => {
      this.initCharts();
      this.initSmallCharts();
    });
  } catch (error) {
    this.$notify({
      type: "danger",
message: (error && error.response && error.response.data) || "Erro ao carregar o dashboard."
    });
  }
},

    filterByYear() {
      this.loadDashboard();
    },

    getSelectedStatusIdsChart() {
      const statusIds = [];
      if (this.selectedStatusesChart.vigente) {
        statusIds.push("VIGENTE");
      }
      if (this.selectedStatusesChart.expirado) {
        statusIds.push("EXPIRADO");
      }
      if (this.selectedStatusesChart.naoIniciado) {
        statusIds.push("NAO_INICIADO");
      }
      return statusIds;
    },

    onAllStatusChangeChart() {
      if (this.selectedStatusesChart.all) {
        this.selectedStatusesChart.vigente = false;
        this.selectedStatusesChart.expirado = false;
        this.selectedStatusesChart.naoIniciado = false;
      }
      this.updateChartWithSelectedStatus();
    },

    onStatusChangeChart() {
      if (this.selectedStatusesChart.vigente || this.selectedStatusesChart.expirado || this.selectedStatusesChart.naoIniciado) {
        this.selectedStatusesChart.all = false;
      } else {
        this.selectedStatusesChart.all = true;
      }
      this.updateChartWithSelectedStatus();
    },

    updateChartWithSelectedStatus() {
      this.initItensChart();
    },

    showOnlyActive() {
      this.selectedStatusesChart.all = false;
      this.selectedStatusesChart.vigente = true;
      this.selectedStatusesChart.expirado = false;
      this.selectedStatusesChart.naoIniciado = false;
      this.updateChartWithSelectedStatus();
    },

    showOnlyExpired() {
      this.selectedStatusesChart.all = false;
      this.selectedStatusesChart.vigente = false;
      this.selectedStatusesChart.expirado = true;
      this.selectedStatusesChart.naoIniciado = false;
      this.updateChartWithSelectedStatus();
    },


    exportToPDF() {
      this.$notify({
        type: 'info',
        message: 'Exportação para PDF será implementada em breve'
      });
    },

    exportToExcel() {
      this.$notify({
        type: 'info',
        message: 'Exportação para Excel será implementada em breve'
      });
    },


    initCharts() {
      this.initItensChart();
      this.initStatusChart();
    },

    initSmallCharts() {
      this.initContratosVigentesLineChart();
      this.initItensLineChart();
      this.initValorLineChart();
      this.initAdesoesLineChart();
    },


    initItensChart() {
      const ctx = document.getElementById('itensChartContratos');
      if (!ctx) return;

      if (this.itensChartContratos) {
        this.itensChartContratos.destroy();
      }

      const monthNames = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ];

      const statusColors = {
        vigentes: {
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)'
        },
        expiradas: {
          backgroundColor: 'rgba(255, 99, 132, 0.6)',
          borderColor: 'rgba(255, 99, 132, 1)'
        },
        naoIniciadas: {
          backgroundColor: 'rgba(255, 206, 86, 0.6)',
          borderColor: 'rgba(255, 206, 86, 1)'
        }
      };

      let datasets = [];
      let statusLabel = '';

      if (this.selectedStatusesChart.all) {
        datasets = [
          {
            label: 'Vigentes',
            data: this.dashboardData.contratosPorMesVigentes || Array(12).fill(0),
            backgroundColor: statusColors.vigentes.backgroundColor,
            borderColor: statusColors.vigentes.borderColor,
            borderWidth: 1
          },
          {
            label: 'Expiradas',
            data: this.dashboardData.contratosPorMesExpiradas || Array(12).fill(0),
            backgroundColor: statusColors.expiradas.backgroundColor,
            borderColor: statusColors.expiradas.borderColor,
            borderWidth: 1
          },
          {
            label: 'Não Iniciadas',
            data: this.dashboardData.contratosPorMesNaoIniciadas || Array(12).fill(0),
            backgroundColor: statusColors.naoIniciadas.backgroundColor,
            borderColor: statusColors.naoIniciadas.borderColor,
            borderWidth: 1
          }
        ];
        statusLabel = 'Todos os Status';
      } else {
        let selectedStatusCount = 0;

        if (this.selectedStatusesChart.vigente) {
          datasets.push({
            label: 'Vigentes',
            data: this.dashboardData.contratosPorMesVigentes || Array(12).fill(0),
            backgroundColor: statusColors.vigentes.backgroundColor,
            borderColor: statusColors.vigentes.borderColor,
            borderWidth: 1
          });
          selectedStatusCount++;
        }

        if (this.selectedStatusesChart.expirado) {
          datasets.push({
            label: 'Expiradas',
            data: this.dashboardData.contratosPorMesExpiradas || Array(12).fill(0),
            backgroundColor: statusColors.expiradas.backgroundColor,
            borderColor: statusColors.expiradas.borderColor,
            borderWidth: 1
          });
          selectedStatusCount++;
        }

        if (this.selectedStatusesChart.naoIniciado) {
          datasets.push({
            label: 'Não Iniciadas',
            data: this.dashboardData.contratosPorMesNaoIniciadas || Array(12).fill(0),
            backgroundColor: statusColors.naoIniciadas.backgroundColor,
            borderColor: statusColors.naoIniciadas.borderColor,
            borderWidth: 1
          });
          selectedStatusCount++;
        }

        if (selectedStatusCount === 1) {
          if (this.selectedStatusesChart.vigente) statusLabel = 'Vigentes';
          else if (this.selectedStatusesChart.expirado) statusLabel = 'Expiradas';
          else if (this.selectedStatusesChart.naoIniciado) statusLabel = 'Não Iniciadas';
        } else {
          statusLabel = 'Status Selecionados';
        }
      }

      this.itensChartContratos = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: monthNames,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: `Quantidade de Contratos ${statusLabel} em ${this.selectedYear}`
          },
          legend: { display: true, position: 'top' },
          tooltips: {
            mode: 'nearest',
            intersect: true,
            callbacks: {
              title: (items) => monthNames[items[0].index] || '',
              label: (item, data) => `${data.datasets[item.datasetIndex].label}: ${item.yLabel}`
            }
          },
          scales: {
            xAxes: [{
              stacked: this.selectedStatusesChart.all || datasets.length > 1,
              ticks: {
                autoSkip: true,
                maxRotation: 0
              }
            }],
            yAxes: [{
              stacked: this.selectedStatusesChart.all || datasets.length > 1,
              ticks: {
                beginAtZero: true,
                stepSize: 1,
                precision: 0
              }
            }]
          }
        }
      });
    },


    initStatusChart() {
      const ctx = document.getElementById('statusChartContratos');
      if (!ctx) return;

      if (this.statusChartContratos) {
        this.statusChartContratos.destroy();
      }

      const total = (this.dashboardData.statusContratos.vigentes || 0) + (this.dashboardData.statusContratos.expiradas || 0) + (this.dashboardData.statusContratos.naoIniciadas || 0);
      const centerTextPlugin = {
        beforeDraw: (chart) => {
          const { width, height, ctx } = chart.chart;
          ctx.save();
          const fontSize = (height / 180).toFixed(2);
          ctx.font = `${fontSize}em Helvetica Neue, Arial, sans-serif`;
          ctx.textBaseline = 'middle';
          ctx.fillStyle = '#6c757d';
          const text = total || 0;
          const textX = Math.round((width - ctx.measureText(text).width) / 2);
          const textY = height / 2;
          ctx.fillText(text, textX, textY);
          ctx.restore();
        }
      };

      this.statusChartContratos = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Vigentes', 'Expiradas', 'Não Iniciadas'],
          datasets: [{
            data: [
              this.dashboardData.statusContratos.vigentes,
              this.dashboardData.statusContratos.expiradas,
              this.dashboardData.statusContratos.naoIniciadas
            ],
            backgroundColor: [
              'rgba(75, 192, 192, 0.6)',
              'rgba(255, 99, 132, 0.6)',
              'rgba(255, 206, 86, 0.6)'
            ],
            borderColor: [
              'rgba(75, 192, 192, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(255, 206, 86, 1)'
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 70,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label: (item, data) => {
                const v = data.datasets[0].data[item.index] || 0;
                const pct = total ? ((v / total) * 100).toFixed(1) : '0.0';
                return `${data.labels[item.index]}: ${v} (${pct}%)`;
              }
            }
          }
        },
        plugins: [centerTextPlugin]
      });
    },

    initContratosVigentesLineChart() {
      const ctx = document.getElementById('contratosVigentesChart');
      if (!ctx) return;

      if (this.contratosVigentesLineChart) {
        this.contratosVigentesLineChart.destroy();
      }

const data = this.dashboardData.contratosPorMesVigentes || Array(12).fill(0);

      this.contratosVigentesLineChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: Array(data.length).fill(''),
          datasets: [{
            data: data,
            borderColor: '#8862e0',
            backgroundColor: 'rgba(136, 98, 224, 0.1)',
            borderWidth: 2,
            fill: true
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            point: {
              radius: 0
            },
            line: {
              tension: 0.4
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: false
            }]
          },
          tooltips: {
            enabled: false
          }
        }
      });
    },

    initItensLineChart() {
      const ctx = document.getElementById('itensLineChartContratos');
      if (!ctx) return;

      if (this.itensLineChartContratos) {
        this.itensLineChartContratos.destroy();
      }

const data = this.dashboardData.distribuicaoItens || Array(12).fill(0);

      this.itensLineChartContratos = new Chart(ctx, {
        type: 'line',
        data: {
          labels: Array(data.length).fill(''),
          datasets: [{
            data: data,
            borderColor: '#047edf',
            backgroundColor: 'rgba(4, 126, 223, 0.1)',
            borderWidth: 2,
            fill: true
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            point: {
              radius: 0
            },
            line: {
              tension: 0.4
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: false
            }]
          },
          tooltips: {
            enabled: false
          }
        }
      });
    },

    initValorLineChart() {
      const ctx = document.getElementById('valorLineChart');
      if (!ctx) return;

      if (this.valorLineChart) {
        this.valorLineChart.destroy();
      }

      const valorBase = this.dashboardData.valorTotalRegistrado ?
        parseFloat(this.dashboardData.valorTotalRegistrado) : 1000000;
      const data = [
        valorBase * 0.7,
        valorBase * 0.8,
        valorBase * 0.75,
        valorBase * 0.85,
        valorBase * 0.9,
        valorBase * 0.95,
        valorBase * 0.92,
        valorBase * 0.98,
        valorBase
      ];

      this.valorLineChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: Array(data.length).fill(''),
          datasets: [{
            data: data,
            borderColor: '#07cdae',
            backgroundColor: 'rgba(7, 205, 174, 0.1)',
            borderWidth: 2,
            fill: true
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            point: {
              radius: 0
            },
            line: {
              tension: 0.4
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: false
            }]
          },
          tooltips: {
            enabled: false
          }
        }
      });
    },

    initAdesoesLineChart() {
      const ctx = document.getElementById('adesoesLineChart');
      if (!ctx) return;

      if (this.adesoesLineChart) {
        this.adesoesLineChart.destroy();
      }

      const data = [2, 3, 2, 4, 3, 5, 4, 6, this.dashboardData.quantidadeAdesoes || 5];

      this.adesoesLineChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: Array(data.length).fill(''),
          datasets: [{
            data: data,
            borderColor: '#fe7096',
            backgroundColor: 'rgba(254, 112, 150, 0.1)',
            borderWidth: 2,
            fill: true
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            point: {
              radius: 0
            },
            line: {
              tension: 0.4
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: false
            }]
          },
          tooltips: {
            enabled: false
          }
        }
      });
    },

    updateCharts() {
      this.initItensChart();
      this.initStatusChart();
    },

    updateSmallCharts() {
      this.initContratosVigentesLineChart();
      this.initItensLineChart();
      this.initValorLineChart();
      this.initAdesoesLineChart();
    },


    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value || 0);
    },


  }
};
</script>

<style scoped lang="scss">
.contrato-dashboard {
  .page-title-header {
    margin-bottom: 1.5rem;

    .page-header {
      padding-bottom: 0;
      border-bottom: none;
      margin-bottom: 1.5rem;

      .page-title {
        font-weight: 500;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
      }

      .quick-links {
        list-style: none;
        padding-left: 0;
        display: flex;
        margin-bottom: 0;

        li {
          display: inline-block;
          margin-right: 1rem;

          a {
            color: #6c757d;
            font-weight: 500;

            &:hover {
              color: #007bff;
              text-decoration: none;
            }
          }
        }
      }
    }

    .page-header-toolbar {
      display: flex;
      align-items: center;
      margin-bottom: 1.5rem;

      .filter-wrapper {
        margin-right: 1rem;
      }

      .sort-wrapper {
        display: flex;
        align-items: center;
      }
    }
  }

  .card {
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    margin-bottom: 1.5rem;

    .card-body {
      padding: 1.5rem;
    }

    .col-md-8.grid-margin.stretch-card .card-body,
    .col-md-4.grid-margin.stretch-card .card-body {
      min-height: 456px;
    }

    .card-title {
      font-weight: 500;
      margin-bottom: 1rem;
    }
  }

  .chart-container {
    position: relative;
    margin: auto;
    max-width: 100%
  }

  .table {
    margin-bottom: 0;

    th {
      font-weight: 500;
      border-top: none;
    }

    td {
      vertical-align: middle;
    }
  }

  .badge {
    padding: 0.4em 0.6em;
    font-size: 80%;
    font-weight: 500;

    &.badge-success {
      background-color: #07cdae;
    }

    &.badge-danger {
      background-color: #fe7096;
    }
  }

@media (max-width: 576px) {
  .chartjs-legend ul {
    flex-direction: column;
    align-items: flex-start;
  }
  .chartjs-legend li {
    margin-right: 0;
    margin-bottom: 0.6rem;
  }
}

  .chartjs-legend {
    ul {
      list-style: none;
      padding-left: 0;
      display: flex;
      flex-wrap: wrap;

      li {
        display: flex;
        align-items: center;
        margin-right: 1rem;

        span {
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-right: 0.5rem;
          border-radius: 50%;
        }
      }
    }
  }

  .wrapper {
    min-height: auto !important;
    height: auto !important;
    position: relative;

    .font-weight-semibold {
      font-weight: 600;
    }

  }

  .border-bottom {
     border-bottom: 1.5px solid var(--color-tabs-border) !important;
  }
  

  .nav-tabs {
    border-bottom: none;

    .nav-item {
      margin-bottom: 0;

      .nav-link {
        border: none;
        padding: 0.5rem 1rem;
        font-weight: 500;
.nav-tabs {
  border-bottom: 1.5px solid var(--color-tabs-border);
}

  
        &:hover {
          border-color: transparent;
        }
      }
    }
  }

  .form-control-local {
    height: 33px;
  }
}


 .contrato-dashboard .wrapper {
  min-width: 0 !important;
  width: 100%;
  max-width: 100%;
overflow: hidden;

}

.contrato-dashboard .wrapper h3,
.contrato-dashboard .wrapper p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  position: relative;
}

.contrato-dashboard .wrapper h3:hover,
.contrato-dashboard .wrapper p:hover {
  white-space: normal;
  overflow: visible;
  z-index: 10;
}
</style>
